import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

// Modern kit exemplar — furniture: authored at true metric size on the tile
// grid (a two-seat sofa spans 2x1 tiles), facing +Z, base on y = 0.
const FABRIC = "#8a9aa8";
const FABRIC_DARK = "#758898";

export const sofaTwoSeat = defineModel({
  id: "sofa-two-seat",
  batchId: "modern",
  name: "Sofa (two-seat)",
  tags: ["modern", "interior", "furniture", "seating", "living-room"],
  summary: "A two-seat contemporary fabric sofa.",
  tiles: { w: 2, h: 1 },
  footprint: 1.3,
  parts(): Part[] {
    return [
      // base frame
      { geometry: new THREE.BoxGeometry(1.9, 0.28, 0.85), color: FABRIC, position: [0, 0.24, 0] },
      // backrest
      { geometry: new THREE.BoxGeometry(1.9, 0.5, 0.2), color: FABRIC, position: [0, 0.6, -0.32] },
      // armrests
      { geometry: new THREE.BoxGeometry(0.18, 0.32, 0.85), color: FABRIC, position: [-0.86, 0.54, 0] },
      { geometry: new THREE.BoxGeometry(0.18, 0.32, 0.85), color: FABRIC, position: [0.86, 0.54, 0] },
      // seat cushions
      { geometry: new THREE.BoxGeometry(0.72, 0.14, 0.62), color: FABRIC_DARK, position: [-0.39, 0.45, 0.05] },
      { geometry: new THREE.BoxGeometry(0.72, 0.14, 0.62), color: FABRIC_DARK, position: [0.39, 0.45, 0.05] },
      // back cushions
      { geometry: new THREE.BoxGeometry(0.72, 0.4, 0.12), color: FABRIC_DARK, position: [-0.39, 0.62, -0.2], rotation: [-0.12, 0, 0] },
      { geometry: new THREE.BoxGeometry(0.72, 0.4, 0.12), color: FABRIC_DARK, position: [0.39, 0.62, -0.2], rotation: [-0.12, 0, 0] },
      // wooden feet
      { geometry: new THREE.BoxGeometry(0.06, 0.1, 0.06), color: "#7a5a3a", position: [-0.85, 0.05, 0.36] },
      { geometry: new THREE.BoxGeometry(0.06, 0.1, 0.06), color: "#7a5a3a", position: [0.85, 0.05, 0.36] },
      { geometry: new THREE.BoxGeometry(0.06, 0.1, 0.06), color: "#7a5a3a", position: [-0.85, 0.05, -0.36] },
      { geometry: new THREE.BoxGeometry(0.06, 0.1, 0.06), color: "#7a5a3a", position: [0.85, 0.05, -0.36] },
    ];
  },
  animations: [],
});
